<template>
  <b-modal
    centered
    size="lg"
    :visible="show"
    hide-footer
    hide-header
    no-close-on-backdrop
    no-close-on-esc
  >
    <b-container v-if="show && order" fluid>
      <b-row>
        <b-col>
          <h4 class="text-info m-2">{{ $t("globals.request_fieldtracker")}}:</h4>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="m-2">
          <label>{{ $t('globals.order_no')}}</label>
          <b-input v-model="order.order_no" disabled />
        </b-col>
        <b-col class="m-2" v-if="order.fieldtracker_reference">
          <label>{{ $t('globals.fieldtracker_reference')}}</label>
          <b-input v-model="order.fieldtracker_reference" disabled />
        </b-col>
      </b-row>
      <b-row>
        <b-col class="m-2">
          <label>{{ $t('globals.company_name')}}</label>
          <b-input v-model="contactInfo.company_name" />
        </b-col>
        <b-col class="m-2">
          <label>{{ $t('globals.phone')}}</label>
          <b-input v-model="contactInfo.contact_phone" />
        </b-col>
      </b-row>
      <b-row>
        <b-col class="m-2">
          <label>{{ $t('globals.first_name')}}</label>
          <b-input v-model="contactInfo.contact_first_name" />
        </b-col>
        <b-col class="m-2">
          <label>{{ $t('globals.last_name')}}</label>
          <b-input v-model="contactInfo.contact_last_name" />
        </b-col>
      </b-row>
      <b-row>
        <b-col class="m-2">
          <label>{{ $t('globals.email')}}</label>
          <b-input v-model="contactInfo.contact_email" />
        </b-col>
        <b-col class="m-2">
          <label>{{ $t('globals.cc_email')}}</label>
          <b-input v-model="contactInfo.cc_email" />
        </b-col>
      </b-row>
      <b-row>
        <b-col class="m-2">
          <label>{{ $t('fieldtracker.requester_name')}}</label>
          <b-input v-model="requester_name" />
        </b-col>
        <b-col class="m-2">
        </b-col>
      </b-row>
      <hr/>
      <b-row>
        <b-col class="m-2">
          <label>{{$t('globals.amount')}}</label>
          <b-input type="number" v-model="currentAmount" />
        </b-col>
        <b-col class="m-2">
          <label>{{$t('globals.type')}}</label>
          <b-select v-model="currentTaskType">
            <option v-for="task_type in getAllTaskTypes" :key="task_type.api_identifier" :value="task_type">
              {{task_type.name}}
            </option>
          </b-select>
        </b-col>
        <b-col sm="2" class="my-2 text-right">
          <br/>
          <b-button variant="primary" @click="createTask" class="mt-2">
            {{$t('globals.add')}}
          </b-button>
        </b-col>
      </b-row>
      <hr/>
      <div v-for="(task, index) in tasks" :key="index" class="mb-4">
        <b-row>
          <b-col sm="4" class="mt-2">
            {{$t('fieldtracker.task_type')}} #{{index + 1}}
          </b-col>
          <b-col class="mt-2">
            <b-select :value="task.task_type.id || null" @change="(id) => setTaskType(id, task)">
              <option v-for="task_type in getAllTaskTypes" :key="task_type.api_identifier" :value="task_type.id">
                {{task_type.name}}
              </option>
            </b-select>
          </b-col>
        </b-row>
        <b-row v-for="(ctf, index) in task.task_type.custom_task_fields" :key="index">
          <b-col sm="4" class="mt-2">
            {{ctf.name}}
          </b-col>
          <b-col class="mt-2" v-if="ctf.api_identifier.includes('imei')">
            <b-input v-model="ctf.value" :state="ctf.valid" @blur="validateImei(ctf.value, ctf)" list="imei_list" v-if="ctf.api_identifier.includes('imei')"/>
            <!-- Select (search) devices -->
            <!-- Search Row -->
            <b-row>
              <b-col>
                <b-input-group size="sm" class="my-1">
                  <b-input-group-prepend is-text>
                    <v-icon name="hdd" :spin="ctf.searchingImei"></v-icon>
                  </b-input-group-prepend>
                  <b-form-input
                    placeholder="IMEI"
                    v-model="ctf.searchImei"
                    @keyup.enter="searchByImei(ctf)"
                    :disabled="ctf.searchingImei"
                  />
                  <b-input-group-append>
                    <b-btn
                      variant="info"
                      @click="searchByImei(ctf)"
                    >
                      <v-icon v-if="ctf.searchingImei" name="spinner" spin></v-icon>
                      <v-icon v-else name="search"></v-icon>
                    </b-btn>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>
            <!-- Result devices table -->
            <b-row v-if="ctf.resultDevices.length > 0">
              <b-col>
                <b-table
                  small
                  primary-key="id"
                  current-page="1"
                  per-page="5"
                  :items="ctf.resultDevices"
                  :fields="fields"
                >
                  <template v-slot:cell(imei)="row">
                    <router-link
                      style="color:#17a2b8"
                      :to="{name: 'device', params:{ id: row.item.id }}"
                    >
                      {{ row.item.imei }}
                    </router-link>
                  </template>
                  <template v-slot:cell(id)="row">
                    <b-btn
                      size="sm"
                      @click="addSelectedDevice(row.item, ctf)"
                    >
                      <v-icon name="plus"></v-icon>
                    </b-btn>
                  </template>
                </b-table>
              </b-col>
            </b-row>
            <hr />
            <datalist id="imei_list" v-if="ctf.api_identifier.includes('imei')">
              <option v-for="device in availableDevices" :key="device.imei" :value="device.imei">
                <small>{{device.product}}</small>
              </option> 
            </datalist>
          </b-col>
          <b-col class="mt-2" v-else>
            <b-input v-model="ctf.value" />
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="4" class="mt-2">
            {{$t('globals.notes')}}
          </b-col>
          <b-col class="mt-2">
            <b-input v-model="task.notes" />
          </b-col>
        </b-row>
        <b-row>
          <b-col class="mt-2 text-right">
            <b-button variant="danger" @click="removeTask(task)">{{$t('globals.remove')}}</b-button>
          </b-col>
        </b-row>
      </div>
      <hr/>
      <b-row>
        <b-col class="m-2">
          <label>{{ $t('globals.postal_code')}}</label>
          <b-input v-model="contactInfo.contact_postal_code" />
        </b-col>
        <b-col sm="2" class="m-2">
          <label>{{ $t('globals.house_number')}}</label>
          <b-input v-model="contactInfo.contact_house_number" />
        </b-col>
        <b-col class="m-2">
          <label>{{ $t('globals.street_name')}}</label>
          <b-input v-model="contactInfo.contact_street" />
        </b-col>
      </b-row>
      <b-row>
        <b-col class="m-2">
          <label>{{ $t('globals.city')}}</label>
          <b-input v-model="contactInfo.contact_city" />
        </b-col>
        <b-col class="m-2">
          <label>{{ $t('globals.country')}}</label>
          <b-input v-model="contactInfo.contact_country" />
        </b-col>
      </b-row>
      <b-row class="text-right">
        <b-col>
          <b-checkbox v-model="set_hq_as_default" class="m-2">
            {{ $t('fieldtracker.use_hq_as_default') }}
          </b-checkbox>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col sm="2">
          <label class="m-2"> {{ $t("globals.notes") }}: </label>
        </b-col>
        <b-col>
          <b-form-textarea
            v-model="notes"
            class="m-2"
            rows="3"
          ></b-form-textarea>
        </b-col>
      </b-row>
      <hr />
      <b-row class="text-right">
        <b-col sm="4">
          <label class="m-2"></label>
        </b-col>
        <b-col>
          <b-form-checkbox v-model="send_sms" class="m-2">
            {{ $t("fieldtracker.send_sms") }}
          </b-form-checkbox>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-btn
            style="float: right; margin: 0.3em;"
            @click="save(true)"
            variant="success"
            :disabled="saveDisabled"
          >
            {{ $t("fieldtracker.save_and_notify") }}
          </b-btn>
          <b-btn
            style="float: right; margin: 0.3em;"
            @click="save(false)"
            variant="secondary"
            :disabled="saveDisabled"
          >
            {{ $t("fieldtracker.save_and_dont_notify") }}
          </b-btn>
          <b-btn
            style="float: left; margin: 0.3em;"
            @click="cancelModal"
            variant="warning"
          >
            {{ $t("globals.cancel") }}
          </b-btn>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    show: Boolean,
    close: Function,
    order: Object,
    devices: Array,
  },
  watch: {
    getUserSystem: function() {
      this.requester_name = this.getUserSystem
    }
  },
  data() {
    return this.initialState();
  },
  methods: {
    ...mapActions("axios_mod", ["simpleMutation", "simpleFetch"]),
    ...mapActions("constants", ["fetchActiveEnums"]),
    ...mapActions("fieldtracker", [
      "fetchTaskTypes",
    ]),
    initialState () {
      let re = /^(\d*[\wäöüß\d '\-\.]+)[,\s]+(\d+)\s*([\wäöüß\d\-\/]*)$/i;
      let address = this.order.customer.shipping_address
      let match = address.match(re);
      let street = null
      let house_number = null

      if (address && match.length > 0) {
        street = match[1]
        house_number = match[2] + " " + match[3]
      }

      let data = {
        filter: null,
        perPage: 10,
        currentPage: 1,
        send_sms: true,
        customTaskFields: null,
        currentTaskType: null,
        tasks: [],
        availableTaskTypes: [],
        currentAmount: 1,
        set_hq_as_default: false,
        saveDisabled: false,
        validDevices: [],
        requester_name: this.getUserSystem,
        contactInfo: {
          cc_email: "",
          company_name: this.order.customer.company_name,
          contact_first_name: this.order.customer.shipping_first_name,
          contact_last_name: this.order.customer.shipping_last_name,
          contact_email: this.order.customer.shipping_email,
          contact_phone: this.order.customer.shipping_phone,
          contact_postal_code: this.order.customer.shipping_postal_code,
          contact_street: street,
          contact_house_number: house_number,
          contact_country: this.order.customer.shipping_country,
          contact_city: this.order.customer.shipping_city
        },
        perPageOptions: [
          { text: "10 " + this.$t("globals.per_page"), value: 10 },
          { text: "20 " + this.$t("globals.per_page"), value: 20 },
          { text: "30 " + this.$t("globals.per_page"), value: 30 }
        ],
        fields: [
          {
            key: "id",
            label: "ID"
          },
          {
            key: "imei",
            label: "IMEI"
          },
          {
            key: "product",
            label: this.$t("globals.product")
          }
        ],
        install_type: {
          selected: "base",
          options: [
            { text: "Base - Already billed (limited amount)", value: "base" },
            { text: "Additional - To be billed separately", value: "additional" }
          ]
        },
        notes: "",
        searchImei: "",
        searchingImei: false,
        resultDevices: [],
      };

      return data;
    },
    save(sendEmail) {
      this.saveDisabled = true;

      // Check if IMEI is valid
      for(let task of this.tasks) {
        for(let ctf of task.task_type.custom_task_fields) {
          if(ctf.api_identifier.includes('imei') && ctf.valid === false) {
            this.saveDisabled = false;
            this.$root.$bvToast.toast("Invalid IMEI", {
              title: "Error",
              variant: "danger",
              noAutoHide: true,
              appendToast: true,
              toaster: "b-toaster-bottom-left"
            });
            this.saveDisabled = false;
            return false
          }
        }
      }

      // Check if devices are selected
      for(let api_identifier in this.selectedTaskTypes) {
        let task_type = this.selectedTaskTypes[api_identifier].task_type
        let service_devices = this.selectedDevicesPerTaskType(task_type).map((d) => { return { device_id: d.id } } )

        if(service_devices.length === 0) {
          this.$root.$bvToast.toast("No devices selected", {
              title: "Error",
              variant: "danger",
              noAutoHide: true,
              appendToast: true,
              toaster: "b-toaster-bottom-left"
            });
          this.saveDisabled = false;
          return false
        }
      }

      if(!confirm(this.$t("globals.are_you_sure"))) {
        this.saveDisabled = false;
        return false
      }

      this.saveToFieldtracker(sendEmail).then((res) => {
        return res;
      }).then((res) => {
        let uuid = res.data.order.uuid
        let result_tasks = res.data.tasks
        let request_reference = res.data.request_reference
        let service_devices = this.validDevices.map((d) => { return { 
          device_id: d.id,
          fieldtracker_reference: result_tasks.find((t) => t.parameters_json.imei === d.imei).uuid,
        }})

        let data = {
          query: `
            mutation FieldtrackerServiceCreate(
              $service: ServiceInput,
              $service_devices: [ServiceDeviceInput]
            ) {
              res: FieldtrackerServiceCreate (
                service: $service
                service_devices: $service_devices
              )
            }
          `,
          variables: {
            service: {
              order_id: parseInt(this.$route.params.id),
              notes: this.notes,
              contact_info: this.contactAllInfo,
              needs_to_be_billed: false,
              fieldtracker_reference: request_reference,
              fieldtracker_task_name: this.selectedTaskTypes[Object.keys(this.selectedTaskTypes)?.[0]]?.task_type?.name,
            },
            service_devices: service_devices
          }
        }

        this.simpleMutation({ data, this_ref: this, skip_confirm: true }).then(() => {
          return res;
        }).then(() => {
          console.log(this.order)
          let data = {
            query: `
              mutation { 
                res: OrderAddFieldtrackerUuid (
                  order_no: ${this.order.order_no},
                  fieldtracker_uuid: "${uuid}"
                )
              }
            `
          };

          this.simpleMutation({ data, this_ref: this, skip_confirm: true }).then(() => {
            this.saveDisabled = false;
            this.tasks = []
            this.contactInfo.cc_email = ""
            this.set_hq_as_default = false
            this.cancelModal();
          }).catch((err) => {
            this.$root.$bvToast.toast('Error while saving order: ' + err, {
              title: "Error",
              variant: "danger",
              noAutoHide: true,
              appendToast: true,
              toaster: "b-toaster-bottom-left"
            });
            this.saveDisabled = false;
            return false;
          });

          // Mutate services with request reference
        }).catch((err) => {
          this.$root.$bvToast.toast('Error while saving to billing: ' + err, {
              title: "Error",
              variant: "danger",
              noAutoHide: true,
              appendToast: true,
              toaster: "b-toaster-bottom-left"
            });
          this.saveDisabled = false;
          return false;
        })
      }).catch((err) => {
        this.$root.$bvToast.toast("Error while saving to fieldtracker" + err, {
              title: "Error",
              variant: "danger",
              noAutoHide: true,
              appendToast: true,
              toaster: "b-toaster-bottom-left"
            });
        this.saveDisabled = false;
        return false;
      }).finally(() => {
        this.saveDisabled = false;
      })
    },
    resetData () {
      Object.assign(this.$data, this.initialState());
    },
    cancelModal() {
      this.saveDisabled = false;
      this.resetData();
      this.close();
    },
    createTask () {
      for(let i = 0; i < this.currentAmount; i++) {
        let task = {
          task_type: JSON.parse(JSON.stringify(this.currentTaskType)),
          notes: ""
        }

        if(task.task_type) {
          for(let cti = 0; cti < task.task_type.custom_task_fields.length; cti++) {
            let ctf = task.task_type.custom_task_fields[cti]
            ctf.value = null
            ctf.searchImei = null
            ctf.searchingImei = false
            ctf.resultDevices = []
            ctf.valid = false
          }
        } else {
          return false
        }

        this.tasks.push(task)
      }
      
      this.currentAmount = 1
      this.currentTaskType = null
    },
    saveToFieldtracker (sendEmail) {
      let fieldtracker_order = {
        id: this.order.order_no,
        send_email: sendEmail,
        send_sms: this.send_sms,
        cc_email: this.contactInfo.cc_email,
        contact_person_company_name: this.contactInfo.company_name,
        contact_person_firstname: this.contactInfo.contact_first_name,
        contact_person_lastname: this.contactInfo.contact_last_name,
        contact_person_phone_number: this.contactInfo.contact_phone,
        contact_person_email: this.contactInfo.contact_email,
        contact_person_postal_code: this.contactInfo.contact_postal_code,
        contact_person_house_number: this.contactInfo.contact_house_number,
        contact_person_street: this.contactInfo.contact_street,
        contact_person_city: this.contactInfo.contact_city,
        contact_person_country: this.contactInfo.contact_country,
        commissioned_by: this.requester_name,
        hq_is_default: this.set_hq_as_default,
        tasks_attributes: this.tasks.map((task) => {
          return {
            identifier: task.task_type.api_identifier,
            parameters: this.customTaskFieldsToObject(task),
            notes_attributes: [
              {
                description: task.notes
              }
            ]
          }
        }),
        notes_attributes: [{
          description: this.notes
        }]
      }

      let url = this.getFieldTrackerUrl + "/orders"

      return axios
              .post(url, {order: fieldtracker_order}, { 
                headers: {
                  Authorization: `Bearer ${this.getFieldtrackerToken}`
                }
              })
    },
    removeTask (task) {
      this.tasks = this.tasks.filter(t => t !== task)
    },
    setTaskType(id, task) {
      this.getAllTaskTypes.forEach(t => {
        if (t.id === parseInt(id) ) {
          task.task_type = JSON.parse(JSON.stringify(t))
        }
      })
    },
    addSelectedDevice (device, custom_task_field) {
      custom_task_field.value = device.imei
      custom_task_field.searchImei = device.imei
      custom_task_field.resultDevices = []
      custom_task_field.valid = true

      this.validateImei(device.imei, custom_task_field)
    },
    searchByImei(ctf) {
      const data = {
        query: `
          query  {
            DeviceLikeImei(
              imei: "${ctf.searchImei}"
              limit: 5
            ) {
              id
              status
              product
              imei
              batch
            }
          }
        `
      };

      ctf.searchingImei = true;
      this.simpleFetch({data, this_ref: this}).then((res) => {
        if (res) {
          ctf.resultDevices = res.DeviceLikeImei
        }
      }).finally(()=>{
        ctf.searchingImei = false;
      });
    },
    validateImei (imei, ctf) {
      if(imei) {
        // Early exit if devices are in order
        for(let i = 0; i < this.devices.length; i++) {
          if(this.devices[i].imei === imei) {
            ctf.valid = true

            let alreadyAdded = false;
            // Check if device is already in validDevices
            for(let j = 0; j < this.validDevices.length; j++) {
              if(this.validDevices[j].imei === imei) {
                alreadyAdded = true;
              }
            }

            if(!alreadyAdded) {
              this.validDevices.push(this.devices[i])
            }
            return true
          }
        }

        const data = {
          query: `
            query  {
              DeviceByImei(
                imei: "${imei}"
              ) {
                id
                status
                product
                imei
                batch
              }
            }
          `
        };
  
        this.simpleFetch({data, this_ref: this}).then((res) => {
          if (res && res.DeviceByImei) {
            ctf.valid = true
            this.validDevices.push(res.DeviceByImei)
          } else {
            this.$root.$bvToast.toast('Invalid iMei', {
              title: "Error",
              variant: "danger",
              noAutoHide: true,
              appendToast: true,
              toaster: "b-toaster-bottom-left"
            });
            ctf.valid = false
          }
        }).catch((err) => {
          this.$root.$bvToast.toast(err, {
              title: "Error",
              variant: "danger",
              noAutoHide: true,
              appendToast: true,
              toaster: "b-toaster-bottom-left"
            });
          ctf.valid = false
        });
      }
    },
    selectedDevicesPerTaskType(task_type) {
      if(!this.selectedTaskTypes[task_type.api_identifier]) {
        return []
      }

      // Convert to set to remove duplicates
      let devices = [...new Set(this.validDevices)]

      return devices.filter(device => {
        for(let task of this.selectedTaskTypes[task_type.api_identifier].tasks) {
          for(let j = 0; j < task.task_type.custom_task_fields.length; j++) {
            let ctf = task.task_type.custom_task_fields[j]
            if (ctf.api_identifier.includes('imei') && ctf.value === device.imei) {
              return true
            }
          }
        }
        return false
      });
    },
    customTaskFieldsToObject (task) {
      let json = {}
      task.task_type.custom_task_fields.forEach(field => {
        json[field.api_identifier] = field.value
      })

      return json
    },
  },
  computed: {
    ...mapGetters("fieldtracker", [
      "getAllTaskTypes", "getFieldtrackerToken"
      // "fetchDevicesLikeCustomer",
    ]),
    ...mapGetters(["getFieldTrackerUrl", "getUserSystem"]),
    base_install() {
      return this.install_type.selected == 'base'
    },
    availableDevices() {
      return this.devices.filter(device => {

        for(let i = 0; i < this.tasks.length; i++) {
          let task = this.tasks[i]
          for(let j = 0; j < task.task_type.custom_task_fields.length; j++) {
            let ctf = task.task_type.custom_task_fields[j]
            if (ctf.api_identifier.includes('imei') && ctf.value === device.imei) {
              return false
            }
          }
        }
        
        return device
      });
    },
    selectedTaskTypes () {
      let task_types = {}

      for(let task of this.tasks) {
        if(task.task_type) {
          if(!task_types[task.task_type.api_identifier]) {
            task_types[task.task_type.api_identifier] = {
              task_type: task.task_type,
              tasks: []
            }
          }

          task_types[task.task_type.api_identifier].tasks.push(task)
        }
      }

      return task_types
    },
    selectedDevices() {
      return this.devices.filter(device => {
        for(let i = 0; i < this.tasks.length; i++) {
          let task = this.tasks[i]
          for(let j = 0; j < task.task_type.custom_task_fields.length; j++) {
            let ctf = task.task_type.custom_task_fields[j]
            if (ctf.api_identifier.includes('imei') && ctf.value === device.imei) {
              return true
            }
          }
        }
        
        return false
      });
    },
    contactAllInfo () {
      let all_info = `${this.contactInfo.contact_first_name} ${this.contactInfo.contact_last_name},\n`
      all_info += `${this.contactInfo.contact_street} ${this.contactInfo.contact_house_number},\n${this.contactInfo.contact_postal_code}, `
      all_info += `${this.contactInfo.contact_city}, ${this.contactInfo.contact_country}\n`
      all_info += `${this.contactInfo.contact_email}\n${this.contactInfo.contact_phone}`

      return all_info
    },
  },
  mounted() {
    this.fetchTaskTypes({
      this_ref: this,
    });

    this.requester_name = this.getUserSystem;
  }
};
</script>
